import React, { ReactElement } from "react"
import PostBaseCard from "./PostBaseCard";
import AudioIcon from "../../../assets/icons/Audio.svg";
import { BlogCardProps } from "./BlogCard";

export interface PodcastCardProps extends BlogCardProps {
    Texture?: React.FunctionComponent<React.SVGAttributes<SVGElement>>,
}

const PodcastCard: React.FC<PodcastCardProps> = ({ title, body, duration, date, tag, type='Podcast', image,
    Texture, className, linkTo='#' }): ReactElement => {
    const MyTexture = Texture as React.FunctionComponent<React.SVGAttributes<SVGElement>>;
    return (
    <PostBaseCard title={title} body={body} duration={duration} date={date} type={type} tag={tag}
        linkTo={linkTo} className={'[&_.post-type]:bg-vibrant-green ' + className}>
        <div className="h-full w-full flex items-end justify-center">
            <div className="flex relative z-10 aspect-square w-[clamp(270px,85%,300px)]" >
                <div className="flex rounded-[50%] border-gray-200 shadow-sm border-8
                    overflow-hidden relative w-full h-full">
                    <img src={image} loading="lazy" className='object-cover max-w-none min-w-full min-h-full'
                    />
                </div>
                <div className="absolute top-[60%] left-0 -translate-x-[30%] bg-[#24135FB3] p-[0.5rem]
                    rounded-[50%] h-[20%] w-[20%] sm:w-[22%] sm:h-[22%] flex items-center justify-center">
                    <AudioIcon />
                </div>
            </div>
            <div className="w-full h-full absolute -bottom-2 left-0 flex items-center
                justify-center">
                {Texture && <MyTexture className="object-cover rotate-180 absolute min-h-full min-w-full" />}
            </div>
        </div>
    </PostBaseCard>
    );
};

export default PodcastCard;
